module.exports = __webpack_public_path__ + "f3fddefd3f6e9e20a4883e3ba7e8a243.woff";


//////////////////
// WEBPACK FOOTER
// ./client/fonts/icons/fonts/icons.woff
// module id = 1078
// module chunks = 0